export { default } from './NewCarBanner';
